import { Box } from "@mui/material";
import { useThemeContext } from "../../globalContext/global-context";
import { OverlaySlot } from "../Wrappers/OverlaySlot";
import CommonImageComp from "./CommonImageComp";

export const ImagePreviewOverlay = () => {
  const { globalObject, previewImage, previewImageEventTrigger } =
    useThemeContext();
  const copy = globalObject.themeData.normalizedTheme.copy;
  return (
    <OverlaySlot
      open={previewImage.isOpen}
      onClose={() => previewImageEventTrigger("", false)}
      size="fullscreen"
      ariaLabel={copy.labels.imagePreview}
      closeLabel={copy.labels.closeImagePreview}
    >
      {previewImage.imageUrl && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <CommonImageComp
            currentVal={{
              image: previewImage.imageUrl,
              alt_text: previewImage.altText ?? copy.labels.previewImage,
            }}
            disablePreviewWrapper
            sourceCanvas={previewImage.sourceCanvas}
            imageTestid="preview-image"
            fillContainer
            imageStyle={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      )}
    </OverlaySlot>
  );
};
